import { render, staticRenderFns } from "./NetaEventBasicDataComponent.vue?vue&type=template&id=4a0ef1d8&scoped=true&"
import script from "./NetaEventBasicDataComponent.vue?vue&type=script&lang=js&"
export * from "./NetaEventBasicDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaEventBasicDataComponent.vue?vue&type=style&index=0&id=4a0ef1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ef1d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0ef1d8')) {
      api.createRecord('4a0ef1d8', component.options)
    } else {
      api.reload('4a0ef1d8', component.options)
    }
    module.hot.accept("./NetaEventBasicDataComponent.vue?vue&type=template&id=4a0ef1d8&scoped=true&", function () {
      api.rerender('4a0ef1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-event/basic-data/NetaEventBasicDataComponent.vue"
export default component.exports